/* LOGIXA homepage content — BG. Shape must match de.ts exactly. */

export const bg = {
  nav: {
    links: [
      { label: 'Продукт', href: '#plattform' },
      { label: 'Решения', href: '#disposition' },
      { label: 'Интеграции', href: '#integrationen' },
      { label: 'Цени', href: '#preise' },
      { label: 'Ресурси', href: '/docs' },
    ],
    login: 'Вход',
    demo: 'Заявете демо',
    menu: 'Меню',
  },

  hero: {
    kicker: 'TRANSPORT MANAGEMENT SYSTEM',
    h1: 'TMS софтуер за спедиции, на които не им стига само диспечирането.',
    sub: 'Поръчки, диспечиране, шофьори, автопарк, GPS, документи и разплащания в една платформа. LOGIXA свързва цялата транспортна организация — от поръчката до фактурата.',
    primary: 'Заявете демо',
    secondary: 'Вижте демо на живо',
    trust: ['Съответствие с GDPR', 'Хостинг в Германия', '9 езика', 'Старт за 12 дни'],
    demoNote: 'Демонстрационни данни',
  },

  mock: {
    search: 'Търсене…',
    user: 'Max Mustermann',
    role: 'ADMIN',
    nav: ['Обзор', 'Поръчки', 'Диспечиране', 'Превозни средства', 'Шофьори', 'Планиране на курсове', 'GPS проследяване', 'Документи', 'Съобщения', 'Отчети', 'Разплащания', 'Настройки'],
    live: 'LIVE',
    card: {
      id: 'FLEET-DEMO-118',
      route: 'Хамбург, DE → Ротердам, NL',
      etaLbl: 'ETA',
      eta: 'Днес, 14:30',
      driverLbl: 'ШОФЬОР',
      driver: 'John D.',
      progress: 64,
    },
    ordersTitle: 'Активни поръчки',
    orders: [
      { id: 'FLEET-DEMO-118', state: 'В ПЪТ', tone: 'go' },
      { id: 'FLEET-DEMO-117', state: 'В ПЪТ', tone: 'go' },
      { id: 'FLEET-DEMO-116', state: 'ТОВАРЕНЕ', tone: 'load' },
      { id: 'FLEET-DEMO-115', state: 'ПЛАНИРАНО', tone: 'plan' },
      { id: 'FLEET-DEMO-114', state: 'ПРИКЛЮЧЕНО', tone: 'done' },
    ],
    kpiTitle: 'KPI днес',
    kpis: [
      { lbl: 'ПОРЪЧКИ', val: '850', delta: '+14 %' },
      { lbl: 'ПРАЗНИ ПРОБЕГИ', val: '14 %', delta: '−16 %' },
      { lbl: 'ПРИХОД', val: '€92K', delta: '+18 %' },
    ],
    statusTitle: 'Статус на автопарка',
    status: [
      { n: '104', lbl: 'В ПЪТ' },
      { n: '18', lbl: 'ТОВАРЕНЕ' },
      { n: '7', lbl: 'РАЗТОВАРВАНЕ' },
      { n: '4', lbl: 'СЕРВИЗ' },
      { n: '2', lbl: 'НЕАКТИВНИ' },
    ],
    plates: [
      { p: 'HH-LOG 33', tone: 'go' },
      { p: 'B-KT 155', tone: 'acc' },
      { p: 'K-AB 147', tone: 'idle' },
    ],
  },

  integrations: {
    label: 'Интеграция във вашата съществуваща\nлогистична инфраструктура',
    items: ['TIMOCOM', 'Trans.eu', 'DATEV', 'Stripe', 'SEPA', 'n8n', 'Make', 'Zapier'],
  },

  platform: {
    kicker: 'ПЛАТФОРМА',
    h2: 'Вашата спедиция. Една система.',
    sub: 'Без Excel таблици. Без отделни системи за шофьори, GPS и разплащания. Без търсене на информация в пет инструмента.',
    areas: [
      {
        n: '01',
        title: 'Поръчки и диспечиране',
        desc: 'Въвеждайте поръчки, разпределяйте шофьори и превозни средства, планирайте курсове и следете статуса на транспорта в реално време.',
        chips: ['Поръчки', 'AI диспечер', 'Планиране', 'ePOD'],
      },
      {
        n: '02',
        title: 'Автопарк и GPS',
        desc: 'Следете превозните средства на живо, планирайте поддръжка, наблюдавайте TCO и управлявайте геозони.',
        chips: ['Live GPS', 'TCO', 'Поддръжка', 'Геозони'],
      },
      {
        n: '03',
        title: 'Шофьори и съответствие',
        desc: 'Работно време, документи, тахограф и правилата EU 561 на едно място — преди сроковете да станат проблем.',
        chips: ['Тахограф', 'EU 561', 'ADR', 'Модул 95'],
      },
      {
        n: '04',
        title: 'Заплати и финанси',
        desc: 'Заплати, добавки, плащания и DATEV процеси, свързани директно с оперативните транспортни данни.',
        chips: ['Payroll', 'DATEV', 'SEPA', 'Stripe'],
      },
    ],
    cta: 'Вижте всички функции',
  },

  dispatch: {
    kicker: 'ИНТЕЛИГЕНТНО ДИСПЕЧИРАНЕ',
    h2: 'Диспечиране, което мисли с вас.',
    sub: 'LOGIXA отчита шофьори, превозни средства, времена на управление, наличност и маршрут и подпомага диспечера при оптималното разпределение.',
    points: [
      { title: 'AI диспечер', desc: 'Предлага шофьор и превозно средство, подходящи за поръчката.' },
      { title: 'Оптимизация на маршрута', desc: 'Отчита такси за път, разстояние, времена на управление и гориво.' },
      { title: 'Diesel Intelligence', desc: 'Планира зареждания по актуалните цени на горивото по маршрута.' },
    ],
    panelTitle: 'Препоръка за маршрут',
    metrics: [
      { lbl: 'Разстояние', val: '1 346 км' },
      { lbl: 'Време в движение', val: '17 ч 25 мин' },
      { lbl: 'Пътни такси', val: '€ 128,40' },
      { lbl: 'CO₂', val: '1 245 кг' },
    ],
    stopsTitle: 'Препоръчани зареждания',
    live: 'LIVE',
    stops: [
      { city: 'Хановер', price: '€ 1,59', best: false },
      { city: 'Касел', price: '€ 1,58', best: false },
      { city: 'Франкфурт', price: '€ 1,55', best: true },
      { city: 'Вюрцбург', price: '€ 1,62', best: false },
    ],
    apply: 'Приеми маршрута',
    source: 'Източници на цени: Tankerkönig (DE), prix-carburants (FR), E-Control (AT), MITECO (ES)',
  },

  driver: {
    kicker: 'ПРИЛОЖЕНИЕ ЗА ШОФЬОРА',
    h2: 'Шофьорът носи всичко със себе си.',
    sub: 'Нативни приложения за iOS и Android — целият ход на курса от поръчката до подписа, включително без мрежа.',
    flow: ['Получаване на поръчка', 'Стартиране на навигация', 'Сканиране на документи', 'Подписване на ePOD', 'Приключване на курса'],
    chips: ['iOS', 'Android', 'Офлайн режим', 'Telegram бот', '9 езика'],
    phones: [
      {
        tag: 'ПОРЪЧКА #DE-1107',
        title: 'Хамбург → Ротердам',
        rows: [
          { lbl: 'ТОВАРЕНЕ', val: 'Днес 08:30' },
          { lbl: 'ДОСТАВКА', val: 'Днес 14:30' },
          { lbl: 'ПРЕВОЗНО СРЕДСТВО', val: 'HH-LOG 33' },
          { lbl: 'ТОВАР', val: '18 палета · 12,4 т' },
        ],
        action: 'Стартирай навигация',
      },
      {
        tag: 'ДОКУМЕНТИ',
        title: 'Сканиране на CMR',
        rows: [
          { lbl: 'ТОВАРИТЕЛНИЦА', val: 'CMR-2026-4471' },
          { lbl: 'СТАТУС', val: 'Сканирано · 2 страници' },
          { lbl: 'ПРИЕМО-ПРЕДАВАТЕЛЕН', val: 'Предстои' },
        ],
        action: 'Качи сканиране',
      },
      {
        tag: 'ePOD',
        title: 'Потвърди получаването',
        rows: [
          { lbl: 'ПОЛУЧАТЕЛ', val: 'De Vries Logistics BV' },
          { lbl: 'ПОДПИС', val: 'Записан' },
          { lbl: 'СНИМКИ', val: '3 прикачени' },
        ],
        action: 'Приключи курса',
      },
    ],
  },

  compliance: {
    kicker: 'СЪОТВЕТСТВИЕ И СИГУРНОСТ',
    h2: 'Виждайте времената на управление, преди да станат проблем.',
    sub: 'Времена на управление и почивка, данни от тахографа и изтичащи документи на едно място — с предупреждение, докато има време за реакция.',
    points: [
      { title: 'EU 561', desc: 'Актуални времена на управление и почивка за всеки шофьор, постоянно съгласувани.' },
      { title: 'Тахограф', desc: 'Импорт на DDD файлове и контрол върху данните на шофьора.' },
      { title: 'Документи', desc: 'Предупреждения преди изтичане на книжка, ADR и Модул 95.' },
    ],
    dashDriverLbl: 'Шофьор',
    dashDriver: 'John D.',
    badge: 'СЪОТВЕТСТВА',
    bars: [
      { lbl: 'Управление днес', val: '7 ч 45 / 9 ч', pct: 86, tone: 'warn' },
      { lbl: 'Управление за седмица', val: '38 ч 10 / 56 ч', pct: 68, tone: 'ok' },
      { lbl: 'Следваща почивка', val: 'след 1 ч 15 мин', pct: 42, tone: 'ok' },
    ],
    docsTitle: 'Изтичащи документи',
    docs: [
      { lbl: 'Шофьорска книжка', val: '12.03.2027', warn: false },
      { lbl: 'ADR сертификат', val: '18.05.2027', warn: true },
      { lbl: 'Модул 95', val: '22.09.2027', warn: false },
    ],
    alerts: '3 АКТИВНИ ПРЕДУПРЕЖДЕНИЯ',
  },

  onboarding: {
    kicker: 'ПРЕХОД',
    h2: 'Още на Excel? Няма проблем.',
    sub: 'Прехвърляме шофьори, превозни средства и контрагенти от Excel, CSV или досегашната ви TMS.',
    promoTitle: 'Старт за 12 дни.',
    promoSub: 'Бързо. Сигурно. Без риск.',
    promoCta: 'Заявете демо',
    steps: [
      { tag: 'ДЕН 1', title: 'Преглед на процесите', desc: 'Демо и анализ на вашите процеси.' },
      { tag: 'ДНИ 2–4', title: 'Старт на пилот', desc: 'Пилотна работа с реални превозни средства.' },
      { tag: 'ДНИ 5–8', title: 'Импорт на данни', desc: 'Прехвърляне на шофьори, автомобили и номенклатури.' },
      { tag: 'ДНИ 9–10', title: 'Обучение на екипа', desc: 'Обучение на диспечери и шофьори.' },
      { tag: 'ДНИ 11–12', title: 'Пускане в реална работа', desc: 'Продуктивен старт с пълна поддръжка.' },
    ],
  },

  roi: {
    kicker: 'ПОТЕНЦИАЛ ЗА ИКОНОМИЯ',
    h2: 'Какво променя LOGIXA във вашия автопарк.',
    fields: [
      { lbl: 'Превозни средства', unit: '' },
      { lbl: 'Шофьори', unit: '' },
      { lbl: 'Поръчки на месец', unit: '' },
      { lbl: 'Ср. км на автомобил годишно', unit: 'км' },
    ],
    panelTitle: 'ПОТЕНЦИАЛ ЗА ГОДИНА',
    lines: ['По-малко административна работа', 'Оптимизирани празни пробеги', 'Оптимизация на горивото'],
    totalLbl: 'Оценен потенциал',
    basisLink: 'Покажи основата на изчислението',
    basisClose: 'Скрий основата на изчислението',
    basis: [
      'Администрация: 7,50 € на поръчка (около 13 минути при ставка за персонал 34 €/час) плюс 15 € на шофьор месечно за отчитане на времето и подготовка на заплатите.',
      'Празни пробеги: 18 % дял на празните километри, от които 5 % избежими чрез по-добро диспечиране, при разход 1,04 € на километър.',
      'Гориво: разход 30 л на 100 км и икономия 2 цента на литър чрез планиране на зарежданията по маршрута — по живи цени от Tankerkönig (DE), prix-carburants (FR), E-Control (AT) и MITECO (ES).',
      'Всички стойности са оценка на база типични отраслови допускания, а не гарантирана икономия.',
    ],
  },

  pricing: {
    kicker: 'ЦЕНИ',
    h2: 'Прозрачни цени. Предвидими. Честни.',
    sub: 'Изберете тарифа според вашия автопарк. Прекратяване всеки месец.',
    allLink: 'Вижте всички цени',
    perMonth: '/ месец',
    badge: 'ПРЕПОРЪЧАН',
    cta: 'Заявете демо',
    plans: [
      {
        name: 'STARTER', price: '€199', custom: false, scope: 'до 15 превозни средства',
        features: ['Управление на поръчки', 'Приложение за шофьора', 'GPS проследяване', 'Имейл поддръжка'],
      },
      {
        name: 'BUSINESS', price: '€499', custom: false, scope: 'до 50 превозни средства',
        features: ['Всички функции на Starter', 'AI диспечер', 'Тахограф и EU 561', 'Приоритетна поддръжка'],
      },
      {
        name: 'ENTERPRISE', price: 'Индивидуално', custom: true, scope: 'над 50 превозни средства',
        features: ['Всички функции на Business', 'Разширени права', 'API и интеграции', 'Личен мениджър'],
      },
    ],
    note: ['По-малките автопаркове започват по-евтино: ', 'BASIC от 49 €/месец', ' за до 3 превозни средства, ', 'DRIVER безплатно', ' за самонаети с един камион.'],
  },

  security: {
    title: 'Вашите данни остават в Европа.',
    items: ['Хостинг в Германия', 'Съответствие с GDPR', '2FA и Passkeys', 'Одит логове', 'Криптиране при съхранение'],
  },

  faq: {
    kicker: 'FAQ',
    h2: 'Често задавани въпроси за TMS софтуер.',
    sub: 'Останаха въпроси? Отговаряме на демото.',
    list: [
      {
        q: 'Какво е TMS софтуер?',
        a: 'Transport Management System обединява обработката на поръчки, диспечирането, управлението на превозни средства и шофьори, документите и разплащанията в една платформа — вместо отделни Excel таблици, GPS портали и счетоводни програми.',
      },
      {
        q: 'За кои спедиции е подходяща LOGIXA?',
        a: 'За спедиции и транспортни фирми от 3 до над 50 превозни средства. Самонаетите с един камион започват с безплатния тарифен план DRIVER, малките автопаркове с BASIC от 49 €/месец, средните фирми със STARTER или BUSINESS.',
      },
      {
        q: 'Може ли LOGIXA да замени Excel?',
        a: 'Да. Поръчки, шофьори, превозни средства, номенклатури и разплащания са в една база данни, а не в разпръснати таблици. Съществуващите Excel и CSV файлове прехвърляме при прехода — стартирате със собствените си данни.',
      },
      {
        q: 'Колко време отнема внедряването?',
        a: 'Планираме прехода за 12 дни: анализ на процесите, пилотна работа с реални превозни средства, импорт на данни, обучение и пускане в реална работа. Този график е нашият подход, а не средна стойност, измерена по клиентски проекти.',
      },
      {
        q: 'Мога ли да запазя настоящия си GPS?',
        a: 'В много случаи да. LOGIXA снема позициите през приложението за шофьора без допълнителен хардуер и успоредно може да приема телематични данни от съществуващи системи. Каква връзка е възможна във вашия случай, изясняваме преди старта.',
      },
      {
        q: 'Поддържа ли LOGIXA тахограф и EU 561?',
        a: 'Времената на управление и почивка по EU 561 се анализират текущо за всеки шофьор, включително предупреждения преди превишаване. DDD файловете от тахографа могат да се импортират и преглеждат; тази обработка не е предназначена като официална разчетка на тахографа пред контролни органи.',
      },
      {
        q: 'Има ли приложение за шофьора?',
        a: 'Да, нативни приложения за iOS и Android на девет езика: поръчка, навигация, сканиране на документи, ePOD подпис и приключване на курса — включително офлайн. Допълнително има Telegram бот за шофьори без инсталирано приложение.',
      },
      {
        q: 'Може ли LOGIXA да се свърже с TIMOCOM и Trans.eu?',
        a: 'Конекторите са подготвени и разработени по документираните интерфейси. Активирането минава през вашия собствен договор с TIMOCOM или Trans.eu; при внедряването настройваме връзката заедно и я тестваме с вашите достъпи.',
      },
      {
        q: 'Къде се съхраняват данните?',
        a: 'На сървъри в Германия, в съответствие с GDPR, криптирани при пренос и при съхранение. Достъпите се протоколират, входът може да се защити с 2FA и Passkeys.',
      },
      {
        q: 'Колко струва LOGIXA?',
        a: 'DRIVER е безплатен за самонаети с един камион, BASIC започва от 49 €/месец за до 3 превозни средства, STARTER струва 199 €/месец до 15 превозни средства, BUSINESS 499 €/месец до 50. Над 50 превозни средства изчисляваме индивидуално. Всички планове се прекратяват месечно.',
      },
    ],
  },

  finalCta: {
    h2: 'Вижте LOGIXA със собствените си транспортни процеси.',
    sub: 'В 30-минутно демо показваме точно тези модули, които са важни за вашия автопарк.',
    primary: 'Заявете демо',
    secondary: 'Вижте демо на живо',
  },

  footer: {
    tagline: 'TMS софтуер за спедиции и транспортни фирми в Европа.',
    cols: [
      {
        title: 'ПРОДУКТ',
        links: [
          { label: 'Функции', href: '/platform/funktionen' },
          { label: 'AI диспечер', href: '/platform/ki' },
          { label: 'Приложение за шофьора', href: '/platform/funktionen#apps' },
          { label: 'Планиране на курсове', href: '/platform/funktionen#tourenplanung' },
          { label: 'Разплащания', href: '/platform/backoffice' },
        ],
      },
      {
        title: 'РЕШЕНИЯ',
        links: [
          { label: 'Малки спедиции', href: '/pricing' },
          { label: 'Средни автопаркове', href: '/pricing' },
          { label: 'Международен транспорт', href: '/platform/funktionen' },
          { label: 'Самонаети шофьори', href: '/pricing' },
        ],
      },
      {
        title: 'ИНТЕГРАЦИИ',
        links: [
          { label: 'TIMOCOM', href: '/platform/integrationen' },
          { label: 'Trans.eu', href: '/platform/integrationen' },
          { label: 'DATEV', href: '/platform/integrationen' },
          { label: 'Telegram', href: '/platform/integrationen' },
          { label: 'Всички интеграции', href: '/platform/integrationen' },
        ],
      },
      {
        title: 'РЕСУРСИ',
        links: [
          { label: 'База знания', href: '/docs' },
          { label: 'Блог', href: '/blog' },
          { label: 'Какво е TMS?', href: '/docs' },
          { label: 'Цена на TMS', href: '/pricing' },
          { label: 'Помощен център', href: '/docs' },
        ],
      },
      {
        title: 'КОМПАНИЯ',
        links: [
          { label: 'За нас', href: '/about' },
          { label: 'Кариери', href: '/jobs' },
          { label: 'Партньори', href: '/companies' },
          { label: 'Контакти', href: '/kontakt' },
        ],
      },
    ],
    copyright: '© 2026 LOGIXA. Всички права запазени.',
    legal: [
      { label: 'Поверителност', href: '/datenschutz' },
      { label: 'Импресум', href: '/impressum' },
      { label: 'Условия', href: '/agb' },
      { label: 'Сигурност', href: '/platform/funktionen#sicherheit' },
    ],
  },
};
